<template>
  <pui-dam-file-viewer
    :file="file"
    :objectFit="objectFit"
    :delayDownloadLength="thumbnailDelayDownloadLength"
    :preventDownload="preventThumbnailDownload"
    class="file-gallery-item-thumbnail-viewer-root"
    classImg="file-gallery-item-image"
  />
</template>

<script>
import puiDamFileViewer, { ObjectFit } from './DamFileViewer';

export { ObjectFit };

export default {
  name: 'pui-file-gallery-item-thumbnail',
  components: {
    puiDamFileViewer,
  },
  props: {
    file: {
      type: Object,
      required: true,
    },
    /**
     * The column at which this is being rendered
     */
    itemColIndex: {
      type: Number,
      required: true,
    },
    /**
     * Object fit mode for the real image
     *
     * @type {String}
     * @default "cover"
     */
    objectFit: {
      type: String,
      default: ObjectFit.COVER,
      validator: value => Object.values(ObjectFit).includes(value),
    },
    /**
     * If can use the 'isParentScrolling' prop to check
     * if the parent is scrolling.
     */
    supportsScrollingDetection: {
      type: Boolean,
      default: false,
    },
    /**
     * If the parent is scrolling
     */
    isParentScrolling: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    /**
     * @returns {number} how long to wait before downloading the thumbnail
     */
    thumbnailDelayDownloadLength() {
      // Delay 200ms to prevent downloading while scrolling
      // Then delay 5 frames per column
      return 200 + this.itemColIndex * ((1000 / 60) * 5);
    },
    /**
     * @returns {boolean} if the thumbnail should not be downloaded
     */
    preventThumbnailDownload() {
      // If we are scrolling, we do not want to download the thumbnail
      return this.supportsScrollingDetection && this.isParentScrolling;
    },
  },
};
</script>
